import * as React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CardTemplate from './CardTemplate';

export default function ReviewContentCard(props: any) {
  const content = props.report.contentBody;
  const isGreeting = props.greeting;
  const reviewContent = !props.post || isGreeting
    ? null
    : (<Typography onClick={ props.open } sx={{ marginBottom: '24px', color: '#033FFF', fontSize: '16px' , fontWeight: '200', textDecoration: 'underline', cursor: 'pointer' }}> View full thread</Typography>);
  const body = (<>
    <Typography sx={{ fontWeight: '600' }}  variant="h6" color="text.black"> { content } </Typography>
    { reviewContent }
    </>);
  const reportIsSafe = <Button variant="contained" sx={{ maxWidth: '120px',  width: '100%', borderRadius: '50px', padding: '12px', backgroundColor: '#02873E' }} size="small">Safe</Button>;
  const reportIsUnsafe = <Button color="error" variant="contained" sx={{ maxWidth: '120px', width: '100%', borderRadius: '50px', padding: '12px' }} size="small">Unsafe</Button>;
  const resolveAsSafeButton = <Button className="btn-resolve safe" color={ props.safe === true ? 'success' : 'inherit' } onClick={ () => props.setSafe(true) } variant="contained" sx={{ width: '100%', borderRadius: '50px', padding: '12px' }} size="small">Resolve as Safe</Button>;
  const resolveAsUnsafeButton = <Button className="btn-resolve unsafe" color={ props.safe === false ? 'error' : 'inherit' } onClick={ () => props.setSafe(false)  } variant="contained" sx={{ width: '100%', borderRadius: '50px', padding: '12px' }} size="small">Post is Unsafe</Button>;
  const moderationActions = (<>
    {resolveAsUnsafeButton}
    {resolveAsSafeButton}
  </>);
  const moderationResult = props.safe
    ? <>{resolveAsUnsafeButton}{reportIsSafe}</>
    : <>{reportIsUnsafe}{resolveAsSafeButton}</>;
  const actions = isGreeting
    ? null
    : props.report.status === "PENDING"
      ? moderationActions
      : moderationResult;
  return (
    <CardTemplate
      title="Review content"
      subtitle="Does this content keep our community safe?"
      body={ body }
      actions={ actions }
    />
  );
}